import {
    getUrnFromArtefactTriplet,
    SDMX_JSON_DATAFLOW_LIST_KEY,
    SDMX_JSON_MAPPING_SET_LIST_KEY
} from "../../../../utils/sdmxJson";

export const categorisationsSorterFactory = (annotationType, lang) => (a, b) => {

    const aOrderAnnot = a.autoAnnotations && a.autoAnnotations.length &&
        a.autoAnnotations.find((ann) => (ann && ann.type === annotationType));
    const bOrderAnnot = b.autoAnnotations && b.autoAnnotations.length &&
        b.autoAnnotations.find((ann) => (ann && ann.type === annotationType));

    if (aOrderAnnot && aOrderAnnot.text && aOrderAnnot.text[lang] && bOrderAnnot && bOrderAnnot.text && bOrderAnnot.text[lang]) {
        return Number(aOrderAnnot.text[lang]) - Number(bOrderAnnot.text[lang]);
    } else {
        return 0;
    }
};


export const getMappingSetsForDataflow = (dataflow, mappingSets) => {
    return mappingSets.filter(
        (mappingSet) => (mappingSet.agency === dataflow.agencyID) && (mappingSet.dataflowId === dataflow.id) && (dataflow.version === (mappingSet.version1 + '.' + mappingSet.version2))
    ).map((mappingSet, idx) => ({
        ...mappingSet,
        categoryUrn: dataflow.categoryUrn,
        dataflowUrn: dataflow.links.find(link => link.rel === "self").urn,
        version: `${mappingSet.version1}.${mappingSet.version2}`,
        id: mappingSet.name,
        urn: getUrnFromArtefactTriplet({
            id: mappingSet.name,
            agencyID: mappingSet.agency,
            version: `${mappingSet.version1}.${mappingSet.version2}`
        }, SDMX_JSON_MAPPING_SET_LIST_KEY),
        parent: dataflow.id,
        type: SDMX_JSON_MAPPING_SET_LIST_KEY,
        links: [{
            rel: "self",
            urn: getUrnFromArtefactTriplet({
                id: mappingSet.name,
                agencyID: mappingSet.agency,
                version: `${mappingSet.version1}.${mappingSet.version2}`
            }, SDMX_JSON_MAPPING_SET_LIST_KEY)
        }, {rel: SDMX_JSON_DATAFLOW_LIST_KEY, urn: dataflow.links.find(link => link.rel === "self").urn}]
    }));
}